



















































































































import Picker from './Picker.vue'
import TemplateBuilder from './TemplateBuilder.vue'
import AddTestClassic from './AddTestClassic.vue'
import AudienceBuilder, { Stages as AudienceStage } from '@/components/AudienceBuilder/AudienceBuilder.vue'
import Modal from '@/components/Modal/Modal.vue'
import ModalContent from '@/components/Modal/ModalContent.vue'
import ModalHeader from '@/components/Modal/ModalHeader.vue'
import ModalFooter from '@/components/Modal/ModalFooter.vue'
import StageNav from './StageNav.vue'
import AjaxButton from '@/components/AjaxButton.vue'
import classicTestTypes, { ClassicTestType } from '@/utilities/classic-test-types'
import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import { Test } from '@shared/types/database'
import store from '@/store'
import { Button } from '@alpha/ink'
import SelectWorkspaceAndProject from './SelectWorkspaceAndProject.vue'
import * as graph from '@shared/types/graphql'
import {
  TemplateSubmissionPayload
} from '@/utilities/template-helpers'
import api from '@/api'
import { Location } from '../Templates/TemplateManager.vue'
import { testURL } from '@/utilities/test-helpers'
import { DEFAULT_TEST_TITLE } from '@/store/modules/test-creation-store-module'
import A from '@/utilities/alpha'
import { DEFAULT_TEMPLATE, SelectedTemplate } from '@/types/frontend'

export enum Stage {
  SelectWorkspaceAndProject,
  Picker,
  TestCreation,
  SelectAudience
}

enum TestType {
  Classic,
  Template
}

@Component({
  components: {
    Picker,
    TemplateBuilder,
    AddTestClassic,
    AudienceBuilder,
    Modal,
    StageNav,
    AjaxButton,
    ModalContent,
    ModalHeader,
    ModalFooter,
    Button,
    SelectWorkspaceAndProject
  }
})
export default class AddTestModal extends Vue {
  @Prop({ default: null }) readonly initialTest!: Test | null
  @Prop({ default: false }) readonly redirect!: boolean
  @Prop({ required: false }) readonly initialTemplate!: SelectedTemplate
  @Ref('template') readonly templateBuilderComponent!: TemplateBuilder
  @Ref('audience') readonly audienceBuilderComponent!: AudienceBuilder
  @Ref('classic') readonly addTestClassicComponent!: AddTestClassic

  loading = false
  validated = false
  stage = Stage.SelectWorkspaceAndProject
  audienceStage = AudienceStage.LIBRARY
  testType = TestType.Classic
  selectedClassicTestType: ClassicTestType | null = null
  templateSubmissionPayload: TemplateSubmissionPayload | null = null
  cloneAudienceId: string = ''
  selectedTemplate: SelectedTemplate = DEFAULT_TEMPLATE
  location = Location.AddTestModal

  clearSelectedAudience = store.dispatch.testCreation.clearSelectedAudience
  addTemplateTest = store.dispatch.testCreation.addTemplateTest
  addClassicTest = store.dispatch.testCreation.addClassicTest
  setStoreTitle = store.dispatch.testCreation.setTitle
  clearTestCreationStore = store.dispatch.testCreation.reset
  setSelectedAudience = store.dispatch.testCreation.setSelectedAudience

  get defaultTestTitle () {
    return DEFAULT_TEST_TITLE
  }

  get classicTestTypes () {
    return classicTestTypes
  }

  get accountId () {
    return store.state.testCreation.workspace?.accountId
  }

  get organizationId () {
    return store.state.testCreation.workspace?.organizationId
  }

  get accountAudiences () {
    return store.state.testCreation.workspace?.accountAudiences || []
  }

  get experiments () {
    return store.getters.workspace.projects
  }

  get validTitle () {
    return store.getters.testCreation.validTitle
  }

  get addTestClassicRedactorComponent (): any {
    return this.addTestClassicComponent?.$refs.redactor
  }

  get selectedAudience () {
    return store.state.testCreation.audience
  }

  get title () {
    return store.state.testCreation.title
  }

  get objective () {
    return store.state.testCreation.objective
  }

  get decisionContext () {
    return store.state.testCreation.decisionContext
  }

  get Stage () {
    return Stage
  }

  get TestType () {
    return TestType
  }

  get showFixedTitle () {
    return this.stage !== Stage.Picker && this.testType !== TestType.Classic
  }

  get readyToSubmit () {
    return this.stage === Stage.SelectAudience &&
      this.selectedAudience
  }

  get showBackButton () {
    return this.stage !== Stage.SelectWorkspaceAndProject
  }

  get showNextButton () {
    switch (this.stage) {
      case Stage.SelectWorkspaceAndProject:
        return !!store.state.testCreation.workspace?.id
      case Stage.SelectAudience:
        return this.audienceBuilderComponent.showNextButton()
      default:
        return true
    }
  }

  get nextButtonText () {
    if (this.newTestExperienceEnabled) {
      return 'Continue'
    } else {
      return 'Next'
    }
  }

  get trackingId () {
    if (this.newTestExperienceEnabled) {
      return 'addTest-continue'
    } else {
      return 'addTest-next'
    }
  }

  created () {
    if (this.initialTest) {
      this.setupForInitialTest()
    }
  }

  setupForInitialTest () {
    if (!this.initialTest) return

    const segment = this.initialTest?.payload.segment
    if (typeof segment === 'string') {
      this.cloneAudienceId = segment
    } else {
      this.cloneAudienceId = segment!.id
    }

    if (this.initialTest.payload.testType === 'Template') {
      this.testType = TestType.Template
    } else {
      this.testType = TestType.Classic
    }
    if (this.testType === TestType.Template) {
      this.selectedTemplate = A.clone(this.initialTemplate)
      store.commit.testCreation.setTitle(this.initialTest.payload.title)
    }
    if (this.testType === TestType.Classic) {
      const matchedClassicTestType = this.classicTestTypes.find(schema => {
        if (this.initialTest?.payload.formtype) {
          const formattedTestType = this.initialTest?.payload.formtype === 'Usability Testing' ? 'Usability' : this.initialTest?.payload.formtype
          return formattedTestType === schema.formName
        } else {
          const formattedTestType = this.initialTest?.payload.testType === 'Usability Testing' ? 'Usability' : this.initialTest?.payload.testType
          return formattedTestType === schema.name
        }
      })

      if (!matchedClassicTestType) {
        throw new Error(`Not test type matches ${this.initialTest.payload.formtype || this.initialTest?.payload.testType}`)
      }

      this.selectedClassicTestType = matchedClassicTestType || null
    }
    this.stage = Stage.TestCreation
  }

  get newTestExperienceEnabled () {
    return store.getters.testCreation.currentWorkspaceHasFeature('newTestExperience')
  }

  async next () {
    switch (this.stage) {
      case Stage.SelectWorkspaceAndProject:
        if (this.newTestExperienceEnabled) {
          await this.createDefaultDraftTestAndRedirect()
        } else if ((await store.dispatch.testCreation.createAndSetProject()).continue) {
          this.stage = Stage.Picker
        }
        break
      case Stage.Picker:
        this.stage = Stage.TestCreation
        break
      case Stage.TestCreation:
        this.stage = Stage.SelectAudience
        break
      case Stage.SelectAudience:
        break
    }
  }

  back () {
    switch (this.stage) {
      case Stage.Picker:
        break
      case Stage.TestCreation:
        this.stage = Stage.Picker
        break
      case Stage.SelectAudience:
        this.backAudienceStage()
        break
    }
  }

  backAudienceStage () {
    switch (this.audienceStage) {
      case AudienceStage.LIBRARY:
        this.stage = Stage.TestCreation
        break
      case AudienceStage.CREATION:
        this.audienceStage = AudienceStage.LIBRARY
        break
    }
  }

  get workspaceId () {
    return store.state.testCreation.workspace!.id
  }

  get projectId () {
    return store.state.testCreation.projectId
  }

  async submit (receiver: AjaxButton, asDraft: boolean) {
    this.loading = true
    const submissionFunction = this.testType === TestType.Classic ? this.submitClassic : this.submitTemplate

    try {
      const successData = await submissionFunction(asDraft)
      await this.updateStoreWorkspaceWithNewTest()
      const testId = successData.id
      if (this.redirect) {
        this.routeToTest(testId)
      }
      this.close()
    } catch (error) {
      if (error && error.message === 'Invalid Test') {
        this.stage = Stage.TestCreation
        setTimeout(() => {
          const invalidFields = document.querySelectorAll('.error-highlight')
          invalidFields[0].scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }, 200)
      } else {
        console.error(error)
      }
      this.validated = true
    }

    receiver.finish()
    this.loading = false
  }

  selectClassicTestType (classicTestType: ClassicTestType) {
    this.testType = TestType.Classic
    this.selectedClassicTestType = classicTestType
    // BUG: https://app.clubhouse.io/alpha-hq/story/529/alpha-classic-is-showing-the-same-description-how-often-do-users-brush-their-teeth-for-every-test
    // Force refresh of redactor to ensure the description placeholder is correct based on the test type
    if (this.addTestClassicRedactorComponent) {
      this.addTestClassicRedactorComponent.$set(this.addTestClassicRedactorComponent, 'forcePlaceHolder', classicTestType.title_placeholder)
      this.addTestClassicRedactorComponent.refresh()
    }
    this.stage = Stage.TestCreation
  }

  selectTemplate (template: graph.Template) {
    this.selectedTemplate = { template, templateValues: null }
    this.testType = TestType.Template
    this.stage = Stage.TestCreation
    store.commit.testCreation.setSelectedTemplateId(template.id)
  }

  async submitTemplate (asDraft: boolean) {
    this.validateTemplate(asDraft)

    const payload = this.templateSubmissionPayload
    if (!payload) {
      throw new Error('No payload')
    }
    payload.title = this.title
    payload.objective = this.objective
    payload.decisionContext = this.decisionContext

    if (asDraft) {
      payload.draft = true
    }
    const test = await this.addTemplateTest({ payload, followUp: this.initialTest?.id })
    this.templateBuilderComponent.didSubmit(test, this.projectId)
    return test
  }

  async submitClassic (asDraft: boolean) {
    if (!this.selectedClassicTestType) {
      throw new Error('Classic test type not selected')
    }
    const result = this.addTestClassicComponent.submit(asDraft)
    if (!result) {
      throw new Error('Invalid Test')
    }
    const { newInsight } = result
    return this.addClassicTest({
      payload: newInsight,
      classicTestType: this.selectedClassicTestType,
      followUp: this.initialTest?.id
    })
  }

  validateTemplate (asDraft: boolean) {
    if (!this.validTitle && asDraft) {
      throw new Error('Invalid Title')
    }

    if (!asDraft) {
      const testValid = this.templateBuilderComponent.submit()
      if (!testValid) {
        throw new Error('Invalid Test')
      } else if (!this.validTitle) {
        throw new Error('Invalid Title')
      }
    }
  }

  close () {
    if (!this.newTestExperienceEnabled) {
      // If we reset on close, it wipes out templates/etc that were loaded to the store when add test modal was opened.
      // This store data is still needed and will need to be wiped out on navigating away from TC instead
      // Should probably just load it on navigation to the page
      this.reset()
    }
    this.$emit('close')
  }

  setTitle (value: string) {
    this.validated = false
    this.setStoreTitle(value)
  }

  reset () {
    this.validated = false
    this.clearTestCreationStore()
  }

  routeToTest (testId: string) {
    this.routeToURL(testURL(this.workspaceId, testId, this.projectId))
  }

  routeToURL (url: string) {
    this.close()
    this.$router.push(url)
  }

  async createDefaultDraftTestAndRedirect () {
    this.loading = true
    const { projectId } = await store.dispatch.testCreation.createAndSetProject()
    const newTest = await store.dispatch.testCreation.addDefaultTest()
    await this.updateStoreWorkspaceWithNewTest()
    if (projectId) {
      await store.dispatch.workspace.updateProject({
        id: projectId,
        projectData: {
          ids: [newTest.id]
        }
      })
    }
    this.loading = false
    this.routeToTest(newTest.id)
  }

  // TODO: this is lame, successData doesn't have all the data we need, and we dont
  // have an api method to get just 1 test, so updating the whole workspace...
  // Lets fix this!
  async updateStoreWorkspaceWithNewTest () {
    // If we're adding a test to a diff workspace, don't set this, it will get loaded on route change
    if (this.workspaceId !== store.state.workspace.workspace.id) return
    const updatedWorkspace = await api.getWorkspaceWithTests(this.workspaceId)
    if (updatedWorkspace) {
      await store.dispatch.workspace.setWorkspace(updatedWorkspace)
    } else {
      console.error('Missing workspace from response')
    }
  }
}
